import React, { useEffect, useState } from "react";
import api from "./services/api";
import { io } from "socket.io-client";
import DeviceRegister from "./components/DeviceRegister";
import DeviceDropdown from "./components/DeviceDropdown";
import DeviceDashboard from "./components/DeviceDashboard";
import DeviceTable from "./components/DeviceTable";

const socket = io(process.env.REACT_APP_API_URL);

function App() {
  const [devices, setDevices] = useState([]);
  const [selected, setSelected] = useState(localStorage.getItem("selectedDevice") || null);

  // fetch devices
  const loadDevices = async () => {
    try {
      const res = await api.get("/devices");
      setDevices(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadDevices();

    // update devices list on real-time updates
    socket.on("dataUpdate", (payload) => {
      // refresh devices list (lightweight)
      loadDevices();
    });

    return () => socket.off("dataUpdate");
  }, []);

  const handleSelect = (deviceId) => {
    setSelected(deviceId);
    localStorage.setItem("selectedDevice", deviceId);
  };

  return (
    <div style={{ padding: 20, fontFamily: "Poppins, sans-serif" }}>
      <h2>IoT Auth Dashboard</h2>

      <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 20 }}>
        <div style={{ flex: "1 1 320px", minWidth: 320 }}>
          <DeviceRegister onRegistered={loadDevices} />
        </div>

        <div style={{ flex: "1 1 320px", minWidth: 320 }}>
          <DeviceDropdown devices={devices} selected={selected} onSelect={handleSelect} />
        </div>
      </div>

      <div style={{ marginBottom: 20 }}>
        <DeviceDashboard selectedDeviceId={selected} />
      </div>

      <DeviceTable devices={devices} onReseted={loadDevices} />
    </div>
  );
}

export default App;
